import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import CreateUserDialog from "../../modals/CreateUserDialog";
import Api from "../../../../Api";
import { PlannerContext } from "../../context/PlannerContext";
import { TeambookUsersPicker } from "../../../default_components/TeambookDefaultPickers";
import WarningModal from "../../../default_components/WarningModal";
import TeambookDialog from "../../../default_components/TeambookDialog";
import PropTypes from "prop-types";

const AddUserGroupedDialog = ({ addUsers, handleClose, project, teamId, teams, allUsers = [] }) => {
  const { t } = useTranslation();

  const { team, bookings } = useContext(PlannerContext);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [addUserWindowOpen, setAddUserWindowOpen] = useState(false);
  const profileRole = localStorage.getItem("tb-role") || "regular";
  const [createdUsers, setCreatedUsers] = useState([]);
  const [creatingUserName, setCreatingUserName] = useState("");
  const [closeConfrimationWindowOpened, setCloseConfirmationWindowOpened] = useState(false);

  const allTeamUsers = team.team_users;

  const closeCreationWindow = () => {
    handleClose();
    setSelectedUsers([]);
  };

  const bookingsArray = [...bookings];
  let addedUserIds = bookingsArray
    .filter((booking) => booking.project_id === project.id)
    .map((booking) => booking.user_id)
    .filter((value, index, self) => self.indexOf(value) === index);

  let usersForOption = allUsers.filter((user) => !addedUserIds.includes(user.id));

  async function addUsersToTeam() {
    const userIds = [...createdUsers, ...selectedUsers]
      .map((user) => {
        if (
          teams
            ?.find((team) => team.id === teamId)
            ?.team_users.map((t) => t.id)
            .includes(user.id)
        ) {
          return null;
        }

        return parseInt(user.id);
      })
      .filter((u) => u);

    if (userIds.length > 0) {
      await Api.Teams.add_users(teamId, userIds).then(() => {
        window.location.reload();
      });
    }
  }

  const addUserToSelected = (users) => {
    setSelectedUsers(users);
  };

  return (
    <>
      <TeambookDialog
        onClose={closeCreationWindow}
        open={true}
        title={t("planning.add_user_group_text")}
        withCloseButton
        content={
          <>
            {allTeamUsers && (
              <TeambookUsersPicker
                fieldName={t("planning.select_users")}
                isCreatable={true}
                filterSelectedOptions
                value={selectedUsers}
                onChange={(newValue) => {
                  addUserToSelected(newValue);
                }}
                defaultValue={selectedUsers}
                onCreateOption={(option) => {
                  setCreatingUserName(option);
                  setAddUserWindowOpen(!addUserWindowOpen);
                }}
                users={usersForOption.map((user) => ({
                  value: user.id,
                  id: user.id,
                  name: user.name,
                }))}
                type="multiple"
              />
            )}
          </>
        }
        actionButtons={[
          {
            text: t("save"),
            onClick: () => {
              addUsersToTeam();
              addUsers([
                ...selectedUsers,
                ...createdUsers.map(({ id, name }) => ({
                  value: id,
                  id: id,
                  name: name,
                })),
              ]);
            },
          },
        ]}
      />

      {addUserWindowOpen && (
        <CreateUserDialog
          setCreatedUsers={setCreatedUsers}
          open={addUserWindowOpen}
          setAddUserWindowOpen={setAddUserWindowOpen}
          profileRole={profileRole}
          selectedUsers={selectedUsers}
          createdUsers={createdUsers}
          currentTeam={teams.find((team) => team.id === teamId)}
          creatingUserName={creatingUserName}
          setCreatingUserName={setCreatingUserName}
          handleClose={handleClose}
          setAddUser={() => {}}
        />
      )}

      {closeConfrimationWindowOpened && (
        <WarningModal
          onNo={() => {
            handleClose();
            setSelectedUsers([]);
            setCloseConfirmationWindowOpened(false);
          }}
          closeModal={() => setCloseConfirmationWindowOpened(false)}
        />
      )}
    </>
  );
};

AddUserGroupedDialog.propTypes = {
  addUsers: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  project: PropTypes.object.isRequired,
  teamId: PropTypes.number.isRequired,
  teams: PropTypes.array.isRequired,
  allUsers: PropTypes.array,
};

export default AddUserGroupedDialog;
